import { render, staticRenderFns } from "./LodgeIcon.vue?vue&type=template&id=5b2f9676&"
import script from "./LodgeIcon.vue?vue&type=script&lang=js&"
export * from "./LodgeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports